import { Box, Tab, Tabs, useMediaQuery } from "@mui/material"
import React, { Children } from "react";
import { theme } from "../../../utils/theme/godzilla_light";

export interface ITabItems {
    tabLabel: string;
    children: JSX.Element;
}
interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: number;
    value: number;
}
interface ITabComponentProps {
    tabsList: ITabItems[];
    handleChange?: any;
    value: any;
    tabWrapperSx?: any;
    tabsSx?: any;
    tabItemSx?: any;
}
const TabsComponent = (props: ITabComponentProps) => {
    const { tabsList, handleChange, value, tabWrapperSx, tabsSx, tabItemSx } = props
    const isMobile = useMediaQuery(theme.breakpoints.down(700));

    function TabPanel(props: TabPanelProps) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`full-width-tabpanel-${index}`}
                aria-labelledby={`full-width-tab-${index}`}
                {...other}>
                {value === index && (
                    <Box sx={{}}>
                        {children}
                    </Box>
                )}
            </div>
        );
    }

    function a11yProps(index: number) {
        return {
            id: `full-width-tab-${index}`,
            'aria-controls': `full-width-tabpanel-${index}`,
        };
    }
    return (
        <Box>
            <Box sx={{ display: "flex", justifyContent: "center", ...tabWrapperSx }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant={isMobile ? "scrollable" : "standard"}
                    scrollButtons={false}
                    aria-label="scrollable auto tabs example"
                    centered={!isMobile}
                    sx={{
                        ...tabsSx,
                    }}>
                    {Children.toArray(tabsList.map((item: any, index: number) => {
                        return (
                            <Tab
                                sx={{ ...theme.typography.poppinsBodySemiBold, ...tabItemSx }}
                                label={item.tabLabel}
                                {...a11yProps(index)}
                            />
                        )
                    }))}
                </Tabs>
            </Box>
            {Children.toArray(tabsList.map((item: any, index: number) => {
                return (
                    <TabPanel value={value} index={index}>
                        {item.children}
                    </TabPanel>
                )
            }))}
        </Box>
    )
}

export default TabsComponent